import { FieldMapping, IXpathFieldMap } from "../models/configuration/xpathFieldMap/IXpathFieldMap";
import { deepEqual } from "./deepEqual";

const normalizeFieldMappings = (
    config?: IXpathFieldMap | FieldMapping[] | null
): FieldMapping[] | null => {
    if (!config) return null;
    if (Array.isArray(config)) return config;
    return config.Configuration?.FieldMappings ?? null;
};

export const hasXPathConfigChanges = (
    current: IXpathFieldMap,
    persisted?: IXpathFieldMap | null
): boolean => {
    const currentMappings = normalizeFieldMappings(current) ?? [];
    const persistedMappings = normalizeFieldMappings(persisted) ?? [];
    return !deepEqual(currentMappings, persistedMappings);
};
